import React, { useState } from 'react'
import { TAG_CLICK_SHARE } from '../analytics/analytics.tagids.constants'
import { isPE } from '../Device'
import { useT } from '../i18n/T'
import copyTextToClipboard from '../utils/Clipboard'
import CircledButtonWithLabel, { LogoVariants } from './CircledButtonWithLabel'
import StatusMessage from './StatusMessage'
import TagActionButton from './TagActionButton'
import { useTemporaryVisible } from './useTemporaryVisible'
import s from './ShareUrlButton.less'
import RectangleActionButton, { COLOR_GREY_EMPTY, SIZE_MEDIUM } from './buttons/RectangleActionButton'
import shareIconUrl from '../genericComponents/assets/share-molecule.svg'

// webpack:BrowserOnly
const ShareUrlButton = ({
  title = 'Mappy',
  description = '',
  logoVariant = LogoVariants.sharpDarkGreyBorder,
  url,
  rectangleButton = false
}) => {
  const [statusText, setStatusText] = useState()
  const [visible, setVisible] = useTemporaryVisible()

  const msgCopyOK = useT('share.link.ok')
  const msgCopyKO = useT('share.link.ko')

  if (!url) return <></>

  const onClick = () => {
    const hasShareSupport = navigator.share

    if (hasShareSupport && isPE()) {
      navigator
        .share({
          title,
          text: description,
          url
        })
        .catch(err => {
          // Ignore user share cancel
          if (err.name !== 'AbortError') throw err
        })
    } else {
      copyTextToClipboard(url)
        .then(() => {
          setStatusText(msgCopyOK)
        })
        .catch(err => {
          console.error('ShareUrlButton clipboard error', err)
          setStatusText(msgCopyKO)
        })
        .finally(() => {
          setVisible(true)
        })
    }
  }

  return (
    <span>
      {rectangleButton ? (
        <RectangleActionButton
          iconUrl={shareIconUrl}
          label="share.action"
          size={SIZE_MEDIUM}
          color={COLOR_GREY_EMPTY}
          tagData={{ type: TAG_CLICK_SHARE }}
          deferClick
          onClick={onClick}
        />
      ) : (
        <TagActionButton type={TAG_CLICK_SHARE} deferClick onClick={onClick}>
          <CircledButtonWithLabel svgUrl={shareIconUrl} label="share.action" logoVariant={logoVariant} />
        </TagActionButton>
      )}
      <StatusMessage message={statusText} visible={visible} className={s.statusMessage} />
    </span>
  )
}

export default ShareUrlButton
